module.exports = __webpack_public_path__ + "img/clampsThinTop.ee672289.svg";